import apiRequest from "../../lib/http"

const BASE_URL = "/workflow"

export const fetchAllConditions = async () => {
  const response = await apiRequest.get(`${BASE_URL}/conditions`)
  return response.data.data
}

export const fetchAllTriggers = async () => {
  const response = await apiRequest.get(`${BASE_URL}/triggers`)
  return response.data.data
}

export const fetchTriggerById = async (id) => {
  const response = await apiRequest.get(`${BASE_URL}/triggers/${id}`)
  return response.data.data
}

export const updateTriggerActions = async (id, actionIds, actionsConfig) => {
  const payload = { actionIds }
  if (actionsConfig) {
    payload.actionsConfig = actionsConfig
  }
  const response = await apiRequest.put(`${BASE_URL}/triggers/${id}/actions`, payload)
  return response.data.data
}

export const createTrigger = async (data) => {
  const response = await apiRequest.post(`${BASE_URL}/triggers`, data)
  return response.data.data
}

export const deleteTrigger = async (id) => {
  const response = await apiRequest.delete(`${BASE_URL}/triggers/${id}`)
  return response.data.data
}

export const duplicateTrigger = async (id) => {
  const response = await apiRequest.post(`${BASE_URL}/triggers/${id}/duplicate`)
  return response.data.data
}

export const fetchAllActions = async (filters = {}) => {
  let url = `${BASE_URL}/actions`

  const params = new URLSearchParams()
  if (filters.type) params.append('type', filters.type)
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive)

  if (params.toString()) {
    url += `?${params.toString()}`
  }

  const response = await apiRequest.get(url)
  return response.data.data
}

export const fetchActionById = async (id) => {
  const response = await apiRequest.get(`${BASE_URL}/actions/${id}`)
  return response.data.data
}

export const fetchActionTypes = async () => {
  const response = await apiRequest.get(`${BASE_URL}/actions/types`)
  return response.data.data
}

export const updateActionConfig = async (id, config) => {
  const response = await apiRequest.put(`${BASE_URL}/actions/${id}/config`, {
    config
  })
  return response.data.data
}

export const toggleAction = async (id) => {
  const response = await apiRequest.patch(`${BASE_URL}/actions/${id}/toggle`)
  return response.data.data
}

export const fetchAvailableFields = async () => {
  const response = await apiRequest.get(`${BASE_URL}/external-api/available-fields`)
  return response.data.data
}

export const fetchWebhookConfig = async () => {
  const response = await apiRequest.get(`${BASE_URL}/external-api/webhook-config`)
  return response.data.data
}

export const generateApiKey = async () => {
  const response = await apiRequest.post(`${BASE_URL}/external-api/generate-api-key`)
  return response.data.data
}

export const fetchUsersBySubRole = async (subRoleValue) => {
  const response = await apiRequest.get(`/users/by-subrole/${subRoleValue}`)
  return response.data.data
}

export const fetchAssignableCoordinators = async () => {
  const response = await apiRequest.get('/users/assignable-coordinators')
  return response.data.data
}
